function initHostActivities(sectionId) {
  console.log("product-parts-item", sectionId);
  // 检查Vue是否已加载
  if (typeof window.Vue === "undefined") {
    console.warn("Vue.js 未加载，host-activities-container使用静态数据");
    return;
  }

  // 获取特定section的数据
  const allHostActivitiesData = window.hostActivitiesData || {};
  const hostActivitiesData = sectionId
    ? allHostActivitiesData[sectionId]
    : allHostActivitiesData;

  if (!hostActivitiesData) {
    console.warn("未找到section数据:", sectionId);
    return;
  }

  console.log("Host Activities Data:", hostActivitiesData);

  // 提取具体数据
  const sectionData = hostActivitiesData.section || {};
  const settings = sectionData.settings || {};
  const blocks = sectionData.blocks || [];
  console.log("Host Activities Section Data:", settings);

  const containerId = sectionId
    ? `#host-activities-container-${sectionId}`
    : "#host-activities-container";

  try {
    var orderSummaryApp = new window.Vue({
      delimiters: ["[[", "]]"],
      el: containerId,
      data: function () {
        // 初始化产品配件的选中状态
        const selectedProductParts = {};
        blocks.forEach((block) => {
          if (block.type === "productParts") {
            const productPart = block.settings.product_parts;
            const defaultVariant = productPart?.variants?.[0];
            // 使用 block.id 作为唯一标识符 根据元数据设置默认选中状态
            selectedProductParts[block.id] =
              Boolean(
                productPart?.is_check &&
                  productPart.available &&
                  defaultVariant?.available
              );
          }
        });

        return {
          sectionData: hostActivitiesData,
          settings: settings,
          blocks: blocks,
          giftCount: hostActivitiesData.gift_count || 0,
          productPartsCount: hostActivitiesData.product_parts_count || 0,
          selectedProductParts: selectedProductParts, // 存储每个产品配件的选中状态
        };
      },
      computed: {
        // 计算属性示例
        mainProduct: function () {
          return this.settings.product || null;
        },
        giftProducts: function () {
          return this.settings.gift_product_list || [];
        },
        productParts: function () {
          return this.blocks.filter((block) => block.type === "productParts");
        },
        coreFunctionImages: function () {
          return this.blocks.filter(
            (block) => block.type === "coreFunctionImg"
          );
        },
      },
      mounted: function () {
        console.log("Vue app mounted with data:", this.$data);
        this.initializeComponent();
      },
      methods: {
        initializeComponent: function () {
          // 初始化组件逻辑
          this.setupEventListeners();
        },
        setupEventListeners: function () {
          // 设置事件监听器
          console.log("Setting up event listeners...");
        },
        // 获取特定类型的块数据
        getBlocksByType: function (type) {
          return this.blocks.filter((block) => block.type === type);
        },
        // 获取产品配件数据
        getProductParts: function () {
          return this.getBlocksByType("productParts");
        },
        // 切换产品配件选中状态
        toggleProductParts: function (blockId, event) {
          console.log("切换产品配件项，Block ID:", blockId);

          // 阻止事件冒泡，避免重复触发
          if (event) {
            event.preventDefault();
          }

          const block = this.blocks.find((item) => item.id === blockId);
          const productPart = block?.settings?.product_parts;
          const defaultVariant = productPart?.variants?.[0];
          if (!productPart?.available || !defaultVariant?.available) return;

          // 使用 Vue.set 来确保响应式更新
          this.$set(
            this.selectedProductParts,
            blockId,
            !this.selectedProductParts[blockId]
          );

          //   console.log("当前选中状态:", this.selectedProductParts);
          //   console.log("选中的产品数量:", this.getSelectedCount());
          //   console.log("选中的产品总价:", this.getSelectedTotal());
          console.log("选中的产品配件:", this.getSelectedProductParts());
        },
        // 获取选中的产品配件数量
        getSelectedCount: function () {
          return Object.values(this.selectedProductParts).filter(
            (selected) => selected
          ).length;
        },
        // 获取选中产品配件的总价格
        getSelectedTotal: function () {
          let total = 0;
          const selectedIds = Object.keys(this.selectedProductParts).filter(
            (id) => this.selectedProductParts[id]
          );

          selectedIds.forEach((blockId) => {
            const block = this.blocks.find((b) => b.id === blockId);
            if (
              block &&
              block.settings.product_parts &&
              block.settings.product_parts.price
            ) {
              total += block.settings.product_parts.price;
            }
          });

          return total;
        },
        // 检查某个产品配件是否被选中
        isSelected: function (blockId) {
          return this.selectedProductParts[blockId] || false;
        },
        // 获取选中的产品配件列表
        getSelectedProductParts: function () {
          const selectedIds = Object.keys(this.selectedProductParts).filter(
            (id) => this.selectedProductParts[id]
          );
          return selectedIds
            .map((blockId) => {
              return this.blocks.find((b) => b.id === blockId);
            })
            .filter((block) => block)
            .map((block) => block.settings.product_parts)
            .filter(
              (part) =>
                part?.available &&
                part.variants?.[0]?.available
            )
            .map((part) => {
              return { id: part.variants[0].id, quantity: 1 };
            });
        },
        addToCart: async function () {
          const itemsToAdd = [];
          itemsToAdd.push({
            id: this.settings.product.variants[0].id,
            quantity: 1,
          }); // 添加主商品
          const selectedProductParts = this.getSelectedProductParts();
          itemsToAdd.push(...selectedProductParts); // 添加选中的产品配件
          try {
            // 添加主商品
            const res = await fetch("/cart/add.js", {
              method: "POST",
              headers: { "Content-Type": "application/json" },
              body: JSON.stringify({ items: itemsToAdd }),
            });

            if (!res.ok) {
              const contentType = res.headers.get("content-type");
              if (contentType && contentType.includes("application/json")) {
                const errorData = await res.json();
                throw new Error(errorData.description || "主商品添加失败");
              } else {
                throw new Error(
                  "请求被拦截（可能是触发了验证码或店铺未公开），请刷新页面后重试。"
                );
              }
            }
            const data = await res.json();

            if (data.items && data.items.length > 0) {
              console.log("✅ 商品添加成功，");

              // 成功添加到购物车，打开购物车抽屉
              document.dispatchEvent(
                new CustomEvent("theme:cartchanged", {
                  bubbles: true,
                  cancelable: false,
                })
              );
              document.dispatchEvent(
                new CustomEvent("theme:open-cart-drawer", {
                  bubbles: true,
                  cancelable: false,
                })
              );
            } else {
              throw new Error("未能添加任何商品, 添加失败");
            }
          } catch (error) {
            console.error("❌ 添加到购物车失败:", error);
            alert("❌ 添加失败: " + error.message + "\n请稍后重试或联系客服。");
          }
        },
      },
    });

    // 全局访问点 - 支持多实例
    window.orderSummaryApps = window.orderSummaryApps || {};
    if (sectionId) {
      window.orderSummaryApps[sectionId] = orderSummaryApp;
    } else {
      window.orderSummaryApp = orderSummaryApp;
    }
    console.log("host-activities-container Vue应用初始化完成", sectionId);
  } catch (error) {
    console.error("host-activities-container 初始化失败:", error);
  }
}

// 导出函数供外部调用
window.initHostActivities = initHostActivities;
